import Card from '@/components/ui/Card'

const events = [
  {
    name: 'Build-A-Bag (Back-to-School)',
    date: 'August',
    blurb: 'Backpacks & supplies for classrooms.',
  },
  {
    name: 'Thanksgiving Drive',
    date: 'November',
    blurb: 'Meals and essentials for families.',
  },
  {
    name: 'Holiday Giving',
    date: 'December',
    blurb: 'Gifts and classroom wish-lists.',
  },
]

export default function Events() {
  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-3xl font-semibold text-cocoa">Events</h1>
        <p className="text-cocoa/70">Highlights from our annual calendar.</p>
      </header>

      <div className="grid gap-4 md:grid-cols-3">
        {events.map((e) => (
          <Card key={e.name} className="space-y-2 p-4">
            <div className="text-lg font-semibold text-cocoa">{e.name}</div>
            <div className="text-xs uppercase tracking-wide text-cocoa/60">{e.date}</div>
            <p className="text-sm text-cocoa/80">{e.blurb}</p>
          </Card>
        ))}
      </div>
    </div>
  )
}
